<template>
  <div style="margin:20px">

    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Actual Mileage Report</span><br/>
      <span style="font-style: italic; font-size: 18px">this view shows calculated actual miles for each vehicle & booking by date vs. Telematics daily totals.  select a row for more details</span>
    </div>

    <!-- one centered row: date + buttons, then count + filters. on narrow screens
         the two groups wrap onto separate lines, each still centered -->
    <div class="mileage-controls">
      <span class="mileage-group">
        <span class="mileage-pair">
          <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)">&lt;</a>
          <date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>
          <span>to</span>
          <date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"></date-picker>
          <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">&gt;</a>
        </span>
        <span class="mileage-pair">
          <b-button v-on:click.prevent="load_data(false)" :disabled="loading">Get Results</b-button>
          <b-button v-on:click.prevent="load_data(true)" :disabled="loading">Rerun Report</b-button>
        </span>
      </span>
      <span v-if="!loading" class="mileage-group">
        <span v-if="summary.total_cnt" class="mileage-count">{{items.length}} of {{summary.total_cnt}}</span>
        <span class="mileage-pair">Filter <b-form-input class="mileage-filter-text" v-model="vehicle_filter" placeholder="charterID,vehicle,driver"/></span>
        <span class="mileage-pair">Mileage Diff <b-form-select class="mileage-filter-diff" v-model="duration_threshold" :options="duration_threshold_options"/></span>
        <span class="mileage-pair">
          <b-form-checkbox v-model="show_idle_rows">Show vehicles with no activity</b-form-checkbox>
        </span>
      </span>
    </div>


    <div v-if="!loading">
      <table width="100%" border='1' cellpadding='0' cellspacing="0">
        <thead>
        <!-- colspans must add up to the column count in the row below: 6 + 9 + 3 + 1 -->
        <tr class="mileage-head-bands">
          <th colspan="6" style="font-size: 18px; font-weight: bold;">&nbsp;</th>
          <th colspan="9" style="background-color: #C6C6C6">Calulated Booking & Driver Actuals</th>
          <th colspan="3" style="background-color: #D5D5D5">Telematics Daily Trips Totals</th>
          <th colspan="1" style="background-color: #A5A5A5">&nbsp;</th>
        </tr>
        <tr class="mileage-head-cols">
          <th width="90px" @click="sort_strings('date')">Date &#8597;</th>
          <th width="80px" @click="sort_strings('vehicle')">Vehicle &#8597;</th>
          <th width="90px" @click="sort_numbers('charterIDs')">BookingID &#8597;</th>
          <th width="90px" @click="sort_numbers('assignmentIDs')">AssignmentID &#8597;</th>
          <th width="80px" @click="sort_strings('drivers')">Driver &#8597;</th>
          <th width="80px" @click="sort_strings('is_multiday')">Is Multiday &#8597;</th>
          <th width="100px" @click="sort_dates('actualClockInTime')">Driver Start &#8597;</th>
          <th width="100px" @click="sort_dates('actualStartLocationTime')">Vehicle Start &#8597;</th>
          <th width="100px" @click="sort_dates('actualStartTripTime')">Trip Start &#8597;</th>
          <th width="100px" @click="sort_dates('actualFinishTripTime')">Trip Finish &#8597;</th>
          <th width="100px" @click="sort_dates('actualFinishLocationTime')">Vehicle Finish &#8597;</th>
          <th width="100px" @click="sort_dates('actualClockOutTime')">Driver Finish &#8597;</th>
          <th width="100px" @click="sort_dates('actualStartOdometer')">Start Odometer &#8597;</th>
          <th width="100px" @click="sort_dates('actualEndOdometer')">End Odometer &#8597;</th>
          <th width="100px" @click="sort_dates('actualTotalDistance')">Total Mileage &#8597;</th>
          <th width="100px" @click="sort_dates('samsaraStartOdometer')">Start Odometer&#8597;</th>
          <th width="100px" @click="sort_dates('samsaraEndOdometer')">End Odometer &#8597;</th>
          <th width="100px" @click="sort_dates('samsaraTotalDistance')">Total Mileage &#8597;</th>
          <th width="100px" @click="sort_dates('diffTotalDistance')">Mileage Diff &#8597;</th>
        </tr>
        </thead>
        <template v-for="(item, row_num) in items">
          <tr @click="toggle_div(item,'isMvmtsVisible')">
            <td>{{ item.date | formatDayLabel }}</td>
            <td>{{ item.vehicle | trim(12)}}</td>
            <td>
              <span v-if="item.charterIDs && item.charterIDs.includes(',')">+{{item.charterIDs.split(',')[0]}}</span>
              <span v-else>{{item.charterIDs}}</span>
            </td>
            <td>
              <span v-if="item.assignmentIDs && item.charterIDs.includes(',')">+{{item.assignmentIDs.split(',')[0]}}</span>
              <span v-else>{{item.assignmentIDs}}</span>
            </td>
            <td>{{ item.drivers | trim(20)}} <span v-if="item.driver_hos_link"><a target="_blank" :href="item.driver_hos_link"><img style="margin: 0px 5px 5px 5px" src="/driver-icon.png"/></a></span></td>
            <td>{{ item.is_multiday}}</td>
            <td>{{item.actualClockInTime | formatDateTimeSmall(item.timezone)}}</td>
            <td>{{item.actualStartLocationTime | formatDateTimeSmall(item.timezone)}}</td>
            <td>{{item.actualStartTripTime | formatDateTimeSmall(item.timezone)}}</td>
            <td>{{item.actualFinishTripTime | formatDateTimeSmall(item.timezone)}}</td>
            <td>{{item.actualFinishLocationTime | formatDateTimeSmall(item.timezone)}}</td>
            <td>{{item.actualClockOutTime | formatDateTimeSmall(item.timezone)}}</td>
            <td>{{item.actualStartOdometer}}</td>
            <td>{{item.actualEndOdometer}}</td>
            <td>{{item.actualTotalDistance}}</td>
            <td>{{item.samsaraStartOdometer}}</td>
            <td>{{item.samsaraEndOdometer}}</td>
            <td>{{item.samsaraTotalDistance}}</td>
            <td>{{item.diffTotalDistance}}</td>
          </tr>
          <tr style="background-color: hsla(120,100%,75%,0.3) !important" v-if="item.isMvmtsVisible" v-for="assignment in item.assignments">
            <td colspan="1">&nbsp;</td>
            <td>{{ assignment.charterID }}</td>
            <td>{{ assignment.assignmentID }}</td>
            <td>{{ assignment.driver }}</td>
            <td>{{ assignment.is_multiday}}</td>
            <td>{{ assignment.actualClockInTime | formatDateTimeSmall(assignment.timezone) }}</td>
            <td>{{ assignment.actualStartLocationTime | formatDateTimeSmall(assignment.timezone) }}</td>
            <td>{{ assignment.actualStartTripTime | formatDateTimeSmall(assignment.timezone) }}</td>
            <td>{{ assignment.actualFinishTripTime | formatDateTimeSmall(assignment.timezone) }}</td>
            <td>{{ assignment.actualFinishLocationTime | formatDateTimeSmall(assignment.timezone) }}</td>
            <td>{{ assignment.actualClockOutTime | formatDateTimeSmall(assignment.timezone) }}</td>
            <td>{{ assignment.actualStartOdometer }}</td>
            <td>{{ assignment.actualEndOdometer }}</td>
            <td>{{ assignment.actualTotalDistance }}</td>
            <td colspan="4">&nbsp;</td>
          </tr>
        </template>
        <tr style="font-weight: bold" v-if="summary">
          <td colspan="13"></td>
          <td>{{ summary.totalBookingMiles }}</td>
          <td colspan="2"></td>
          <td>{{ summary.totalSamsaraMiles }}</td>
          <td>{{ summary.totalDiffMiles }}</td>
        </tr>
      </table>
    </div>
    <div v-else-if="loading">
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>

</template>
<script>
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import {get_tbn_actuals_mileage_report} from "../networking/tbn_apis";
import {MAX_RANGE_DAYS, chunk_range, day_count, is_idle_row} from "../utils/mileage_range";

export default {
  name: 'actuals_mileage_tbn',

  components: {
  },

  data() {
    return {
      items: [],
      items_full: [],
      summary: [],
      loading: false,
      vehicle_filter: null,
      selected_vehicle_type: null,
      details_fromDate: justDate(moment().subtract(1, 'days')),
      details_toDate: justDate(moment().subtract(1, 'days')),
      progress_done: 0,
      progress_total: 0,
      vehicle_type_options: [],
      duration_threshold: null,
      show_idle_rows: false,
      duration_threshold_options: [
        { value: null, text: 'All' },
        { value: '10', text: '> 10 mi' },
        { value: '15', text: '> 15 mi' },
        { value: '30', text: '> 30 mi' },
        { value: '45', text: '> 45 mi' },
        { value: '60', text: '> 60 mi' },
        { value: '120', text: '> 120 mi' },
      ],
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(360, 'days'),
        maxDate: moment(),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  async created() {
    this.check_features()
  },
  filters: {
    // the rows carry a plain YYYY-MM-DD from the report, so this stays off the
    // timezone-aware filters in main.js
    formatDayLabel(day) {
      return day ? moment(day, 'YYYY-MM-DD').format('ddd M/D') : ''
    },
  },

  methods: {
    async check_features() {

    },
    async load_data(reprocess) {
      const from_moment = moment(this.details_fromDate, 'MM-DD-YYYY')
      const to_moment = moment(this.details_toDate, 'MM-DD-YYYY')

      if (!from_moment.isValid() || !to_moment.isValid()) {
        this.$emit('showAlert', 'please choose a start and end date', 'warning', 8000)
        return
      }

      const from = from_moment.format('YYYY-MM-DD')
      const to = to_moment.format('YYYY-MM-DD')
      const num_days = day_count(from, to)

      if (num_days < 1) {
        this.$emit('showAlert', 'the end date is before the start date', 'warning', 8000)
        return
      }
      if (num_days > MAX_RANGE_DAYS) {
        this.$emit('showAlert', 'please choose a range of ' + MAX_RANGE_DAYS + ' days or less', 'warning', 8000)
        return
      }

      // the endpoint answers a week per request so no single call runs into the 29s
      // api gateway cutoff; a longer range is fetched a week at a time
      const chunks = chunk_range(from, to)

      this.loading = true
      this.selected_vehicle_type = ''
      this.sort_col = 'vehicle'
      this.progress_done = 0
      this.progress_total = chunks.length

      const results = []
      try {
        for (const [chunk_from, chunk_to] of chunks) {
          const { value: { data = [] }} = await get_tbn_actuals_mileage_report(
            this.user.tenant, chunk_from, reprocess, chunk_to)
          this.summary = data.summary
          moment.tz.setDefault(this.summary.timezone)
          this.vehicle_type_options = data.summary.vehicle_types
          results.push(...(data.results || []))
          this.progress_done += 1
        }
      } catch (e) {
        this.$emit('showAlert', 'we could not load that range, please try a shorter one', 'warning', 15000)
        this.loading = false
        return
      }

      this.items = results
      this.items_full = results
      this.filter_items()
      this.loading = false
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    async shift_detail_graph_date(shift) {
      const from = moment(this.details_fromDate, 'MM-DD-YYYY')
      const to = moment(this.details_toDate, 'MM-DD-YYYY')
      if (!from.isValid() || !to.isValid()) {
        return
      }
      const span = to.diff(from, 'days') + 1
      const next_to = to.clone().add(shift * span, 'days')
      const today = moment().startOf('day')
      const capped_to = next_to.isAfter(today) ? today : next_to
      this.details_fromDate = capped_to.clone().subtract(span - 1, 'days').format('MM-DD-YYYY')
      this.details_toDate = capped_to.format('MM-DD-YYYY')
    },
    filter_items() {
      this.items = this.items_full
      if (this.selected_vehicle_type != '')
        this.items = this.items.filter(item => item.vehicle_type == this.selected_vehicle_type)
      if (this.vehicle_filter) {
        this.items = this.items.filter(item => (this.contains(item.charterIDs,this.vehicle_filter) || (this.contains(item.assignmentIDs,this.vehicle_filter) || this.contains(item.drivers,this.vehicle_filter) || this.contains(item.vehicle,this.vehicle_filter))))
      }
      if (this.duration_threshold)
        this.items = this.items.filter(item => (Math.abs(item.diffTotalDistance) > this.duration_threshold))
      // a week of 30 buses is mostly yard days; they are hidden unless asked for
      if (!this.show_idle_rows) {
        this.items = this.items.filter(item => !is_idle_row(item))
      }
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    },
    sort_dates(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          // console.log("sort:" + a[col] + ", " + b[col])

          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return new Date(a[col]) - new Date(b[col])
          }
        })
      }
      this.sort_col = col
    },
    sort_numbers(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            if (a[col] && a[col].includes(','))
              a[col] = a[col].split(',')[0]

            if (b[col] && b[col].includes(','))
              b[col] = b[col].split(',')[0]

            return a[col] - b[col]
          }
        })
      }
      this.sort_col = col
    },
    sort_strings(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {

            if (a[col] && a[col].includes(','))
              a[col] = a[col].split(',')[0]

            if (b[col] && b[col].includes(','))
              b[col] = b[col].split(',')[0]

            let fa = a[col].charAt(0).toLowerCase(),
                fb = b[col].charAt(0).toLowerCase();

            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          }
        })
      }
      this.sort_col = col
    }

  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    selected_vehicle_type(val) {
      this.filter_items()
    },
    duration_threshold() {
      this.filter_items()
    },
    show_idle_rows() {
      this.filter_items()
    },
    vehicle_filter() {
      this.filter_items()
    }
  }
}
</script>
<style scoped>

.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }
a {color: darkred}

thead {
  position: sticky;
  /* the horizon shell's top nav and favorites bar are fixed, so sticking at 0 puts
     the header underneath them. fi_favorites_bar.vue publishes its own height in
     --fi-hz-top-offset (52px plus the bar), the same variable the section nav and the
     vsm boards stick to. */
  top: var(--fi-hz-top-offset, 52px);
  z-index: 999;
}
th {
  background-color: #F9F8F8;
  border: 1px solid black;
}

tr:nth-child(even) {
  background-color: #f2f2f2 !important;
}

.mileage-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 12px 40px;
  margin: 20px 0;
  font-size: 22px;
  font-weight: bold;
}
/* groups wrap as whole units first; only on very narrow screens do their own
   pieces wrap, and those lines stay centered too */
.mileage-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 12px 20px;
}
/* a label or arrow never separates from its control */
.mileage-pair {
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  /* the date picker drops its calendar in beside the input and positions it
     absolutely, so this has to be the positioned ancestor or it lands at the
     bottom of the page */
  position: relative;
}
.mileage-count {
  border: 1px solid grey;
  padding: 2px 24px;
  white-space: nowrap;
}
.mileage-filter-text {
  width: 250px;
  max-width: 60vw;
}
.mileage-filter-diff {
  width: 110px;
  font-size: 20px;
  font-weight: bold;
}

</style>


